// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconLinkEraserInactive: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="currentColor">
            <path
                fill="#currentColor"
                d="M4.27757353,10.4 L7.21691176,10.4 L8.77022059,8.775 L4.61213235,4.425 L1.60110294,7.6 L4.27757353,10.4 Z M5.35294118,12 L4.27757353,12 C3.87132353,12 3.46507353,11.825 3.17830882,11.525 L0.40625,8.625 C0.143382353,8.35 0,7.975 0,7.6 C0,7.225 0.143382353,6.85 0.40625,6.575 L6.28492647,0.425 C6.54779412,0.15 6.90625,0 7.26470588,0 C7.62316176,0 7.98161765,0.15 8.24448529,0.425 L12.59375,4.975 C12.8566176,5.25 13,5.625 13,6 C13,6.375 12.8566176,6.75 12.59375,7.025 L9.36764706,10.4 L12.2352941,10.4 C12.6654412,10.4 13,10.75 13,11.2 C13,11.65 12.6654412,12 12.2352941,12 L5.35294118,12 Z"
            />
        </svg>
    );
};

export default React.memo(IconLinkEraserInactive);
